module.exports = __webpack_public_path__ + "static/img/policyType4-entry.81331be7.png";